import { screenSelector } from "@client/selectors/state";
import { ScreenType } from "@client/types";
import {
  isMenuOverlay,
  isMenuSlide,
  menuEffectSelector,
  menuVisibilitySelector
} from "@client/widgets/Header/selectors";
import { createSelector } from "reselect";
import { type HeaderMenuToggleContainerProps } from "./container";

const isLeftSelector = (state: any, props: HeaderMenuToggleContainerProps) => props.isLeft;

export const makeIsVisibleSelector = () =>
  createSelector(
    [screenSelector, menuEffectSelector, menuVisibilitySelector, isLeftSelector],
    (screen, menuEffect, visibility, isLeft): boolean =>
      visibility.isVisible &&
      ((isLeft && screen !== ScreenType.Desktop) ||
        (!isLeft && screen === ScreenType.Desktop && (isMenuSlide(menuEffect) || isMenuOverlay(menuEffect))))
  );
